<template>
  <article class="agreement-wrapper">
    <div>
      <perfect-scrollbar
        :options="{ suppressScrollX: true }"
      >
        <div class="agreement-header">
          <div class="agreement-title">
            Договор оказания услуг
          </div>
          <div v-if="isLoaded" class="agreement-organization-name">
            {{ organizationName }}
          </div>
          <v-skeleton-loader
            v-else
            type="heading"
          ></v-skeleton-loader>
        </div>
        <div v-if="isLoaded" class="agreement-text" v-html="html" />
        <template v-else>
          <div class="agreement-text">
            <v-skeleton-loader type="heading" class="mb-3"></v-skeleton-loader>
            <v-skeleton-loader type="paragraph" class="mb-3"></v-skeleton-loader>
            <v-skeleton-loader type="sentences" class="mb-3"></v-skeleton-loader>
            <v-skeleton-loader type="sentences" class="mb-3"></v-skeleton-loader>
            <v-skeleton-loader type="paragraph" class="mb-3"></v-skeleton-loader>
            <v-skeleton-loader type="paragraph"></v-skeleton-loader>
          </div>
        </template>
      </perfect-scrollbar>
    </div>
  </article>
</template>

<script>
  import Loader from '@/components/loader/Loader'

  export default {
    name: 'ConnectionAgreement',
    components: { Loader },
    props: {
      organization: Object,
      html: String,
    },
    data () {
      return {
        scrollbarOptions: {
          suppressScrollX: true,
        },
      }
    },
    computed: {
      isLoaded () {
        return this.organization && this.html
      },
      organizationName () {
        return this.organization?.name ? `(${this.organization.name.toUpperCase()})` : ''
      },
    },
  }
</script>

<style lang="less" scoped>
::v-deep {
  strong {
    color: #0C0C0C;
    font-weight: 500;
    text-align: center;
  }
  table {
    border-collapse: collapse;
  }
  th, td {
    padding: 10px 15px;
    border: 1px solid #000;
  }
  th {
    font-weight: bold !important;
  }
}

.agreement {
  &-wrapper {
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-top: 1px solid rgba(0, 0, 0, 0.3);
    border-left: 1px solid rgba(0, 0, 0, 0.3);
    //padding: 25px 20px 20px 20px;
  }

  &-header {
    padding: 25px 20px 15px 20px;
    position: sticky;
    top: 0;
    background: #fff;
  }

  &-title {
    font-size: 28px;
    font-weight: bold;
    color: #0C0C0C;
    margin-bottom: 15px;
    text-transform: uppercase;
  }

  &-organization-name {
    font-size: 20px;
    font-weight: 400;
    color: #0C0C0C;
    text-transform: uppercase;
  }

  &-text {
    max-height: 45vh;
    font-size: 16px;
    color: #030303;
    line-height: 1.4;
    padding: 0 20px 20px 20px;

      li {
        line-height: 1.3 !important;
      }

  }

  &-paragraph-title {
    color: black;
    margin-bottom: 12px;
  }
}
</style>
